import { FileText } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Bouton } from '../ui/composants/bouton'
import { ChampRecherche } from '../ui/composants/champ-recherche'
import { EnteteSection } from '../ui/composants/entete-section'
import { LIBELLES_STATUT } from '../lib/devis'
import { rechercher } from '../lib/recherche'
import { LigneDevis, useDevisAvecClient } from '../ui/liste-devis'
import { BarreActions } from '../ui/synchro'

export default function Devis() {
  const devis = useDevisAvecClient()
  const [recherche, setRecherche] = useState('')
  const devisAffiches = devis && rechercher(devis, recherche, (d) => [d.clientNom, d.numero, LIBELLES_STATUT[d.statut], d.avenantDe ? 'avenant' : undefined])

  return (
    <>
      <main className="flex flex-1 flex-col gap-4 p-4">
        <EnteteSection Icone={FileText} titre="Devis" description="Créer, suivre et faire signer vos devis." />
        {devis?.length === 0 && <p className="text-slate-700">Aucun devis pour l'instant : « + Devis » pour commencer.</p>}
        {(devis?.length ?? 0) > 5 && (
          <ChampRecherche libelle="Rechercher un devis (client, numéro, état)" placeholder="Client, numéro, état…" value={recherche} onChange={setRecherche} />
        )}
        {devisAffiches?.length === 0 && recherche.trim() && <p className="text-slate-700">Aucun devis ne correspond à « {recherche} ».</p>}
        <ul className="flex flex-col gap-2">
          {devisAffiches?.map((d) => (
            <li key={d.id}>
              <LigneDevis d={d} />
            </li>
          ))}
        </ul>
      </main>

      <BarreActions>
        <Bouton asChild className="flex-1">
          <Link to="/devis/nouveau">+ Devis</Link>
        </Bouton>
      </BarreActions>
    </>
  )
}
